// extracted by mini-css-extract-plugin
export default {"modalSubtitle":"ChooseTicketModalContentInput_modalSubtitle__-49iL","ticketContainer":"ChooseTicketModalContentInput_ticketContainer__ckElE"};